export function mergeOptions(target, options) {
    if (!isObject(target)) {
        return options;
    }
    if (!isObject(options)) {
        return target;
    }
    Object.keys(options).forEach(key => {
        if (options[key] && !target[key]) {
            target[key] = options[key];
            return;
        }
        if (isObject(target[key]) && isObject(options[key])) {
            mergeOptions(target[key], options[key]);
        }
        else {
            const isType = Object.prototype.toString.call(options[key]).toLowerCase() === Object.prototype.toString.call(target[key]).toLowerCase();
            if (!isType && target[key] !== undefined) {
                throw new Error(`params ${key}  must be ${typeof target[key]}`);
            }
            else {
                target[key] = options[key];
            }
        }
    });
}
export function isObject(target) {
    return Object.prototype.toString.call(target).toLowerCase() === '[object object]';
}
export const drawCircle = (ctx, vertex, radius, options) => {
    ctx.save();
    if (!options.hasOwnProperty('dashed') || options.dashed === false) {
        ctx.setLineDash([]);
    }
    else {
        const _dashedConfig = options.dashedConfig && options.dashedConfig.length ? options.dashedConfig : [5, 5, 5];
        ctx.setLineDash(_dashedConfig);
    }
    const { lineColor, opacity } = options;
    // console.log('vertex.x in draw', vertex.x)
    ctx.beginPath();
    ctx.arc(vertex.x, vertex.y, radius, 0, 2 * Math.PI, false);
    ctx.fillStyle = hex2rgba(lineColor[0], opacity);
    ctx.fill();
    ctx.closePath();
    ctx.restore();
};
export const drawLayeredCircle = (ctx, vertex, radius, options) => {
    ctx.save();
    if (!options.hasOwnProperty('dashed') || options.dashed === false) {
        ctx.setLineDash([]);
    }
    else {
        const _dashedConfig = options.dashedConfig && options.dashedConfig.length ? options.dashedConfig : [5, 5, 5];
        ctx.setLineDash(_dashedConfig);
    }
    const { lineColor, weight, opacity } = options;
    // console.log('vertex.x in draw', vertex.x)
    ctx.beginPath();
    ctx.arc(vertex.x, vertex.y, radius, 0, 2 * Math.PI, false);
    ctx.fillStyle = hex2rgba(lineColor[0], opacity);
    ctx.fill();
    ctx.closePath();
    if (lineColor.length <= 1) {
        return; // assume with up to 2 color
    }
    ctx.beginPath();
    ctx.arc(vertex.x, vertex.y, radius + (radius || 0) / 2, 0, 2 * Math.PI, false);
    ctx.lineWidth = radius;
    ctx.strokeStyle = lineColor[1];
    ctx.stroke();
    ctx.restore();
};
export function hex2rgba(hexColor, opacity) {
    const hex = hexColor.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const result = `rgba(${r}, ${g}, ${b}, ${opacity})`;
    return result;
}
export function transformVertex(event, zoom = 1) {
    const { offsetX: x, offsetY: y } = event;
    return { x: x / zoom, y: y / zoom };
}
export function transformXY(vertex, zoom = 1) {
    return { x: vertex.x / zoom, y: vertex.y / zoom };
}
export function drawRoundRect(ctx, roundRect, options) {
    // start 为左上角第一个顶点坐标
    const { start, width, height, radius } = roundRect;
    const { x, y } = start;
    ctx.beginPath();
    ctx.moveTo(x, y);
    // 上边线
    ctx.lineTo(x + width, y);
    // 右上圆角
    ctx.arcTo(x + width + radius, y, x + width + radius, y + radius, radius);
    // 右边线
    ctx.lineTo(x + width + radius, y + height + radius);
    // 右下圆角
    ctx.arcTo(x + width + radius, y + height + 2 * radius, x + width, y + height + 2 * radius, radius);
    // 下边线
    ctx.lineTo(x, y + height + 2 * radius);
    // 左下圆角
    ctx.arcTo(x - radius, y + height + 2 * radius, x + -radius, y + height + radius, radius);
    // 左边线
    ctx.lineTo(x - radius, y + radius);
    // 左上圆角
    ctx.arcTo(x - radius, y, x, y, radius);
    ctx.lineTo(x, y);
    ctx.closePath();
    ctx.fillStyle = options.fillColor;
    ctx.lineWidth = options.weight;
    ctx.strokeStyle = options.lineColor;
    ctx.stroke();
    ctx.fill();
}
export const getAngle = (p1, p2) => {
    const radian = Math.atan2(-(p1.y - p2.y), -(p1.x - p2.x));
    let angle = radian * (180 / Math.PI);
    if (angle < 0) {
        angle = angle + 360;
    }
    return angle;
};
export const getPerpVertex = (p1, p2, distance = 10) => {
    const perPAngle = getAngle(p1, p2);
    let rotateAngle = perPAngle - 90;
    if (rotateAngle < 0) {
        rotateAngle = rotateAngle + 360;
    }
    const { midX, midY } = computeMid(p1, p2);
    const pointX = Math.round(Math.cos((rotateAngle * Math.PI) / 180) * distance + midX);
    const pointY = Math.round(Math.sin((rotateAngle * Math.PI) / 180) * distance + midY);
    const res = { x: pointX, y: pointY, rotate: rotateAngle };
    return res;
};
const computeMid = (p1, p2) => {
    const diffX = p2.x - p1.x;
    const diffY = p2.y - p1.y;
    const midX = p1.x + diffX / 2;
    const midY = p1.y + diffY / 2;
    return { midX, midY: midY - 20 };
};
export const calibrateLine = (p, vertices) => {
    if (checkClockwise(vertices) < 0) {
        return { from: p.to, to: p.from };
    }
    return p;
};
const checkClockwise = (vertices) => {
    let area = 0;
    for (let i = 0, j = 0; i < vertices.length; i++) {
        j = (i + 1) % vertices.length;
        area += vertices[i].x * vertices[j].y;
        area -= vertices[j].x * vertices[i].y;
    }
    return area / 2;
};
export const getEndPoint = (start, angle, distance = 30) => {
    let pointAngle = angle;
    if (pointAngle < 0) {
        pointAngle = pointAngle + 360;
    }
    const angleToRadius = pointAngle * (Math.PI / 180);
    const endX = start.x + Math.cos(angleToRadius) * 30;
    const endY = start.y + Math.sin(angleToRadius) * 30;
    console.log('endX:', endX);
    return { x: endX, y: endY };
};
